import React, { Dispatch, SetStateAction } from 'react';
import { Icon, Modal, Button } from 'ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { routes } from '../../../config/config';
import { ButtonListModal } from '../../../styles/layout/form';
import useSessionStorage from 'utils/useSessionStorage';
import { useLocation } from 'react-router-dom';
import { useAuthDispatch, useAuthState } from '../../../contexts/AuthContext';
import { Flex } from 'antd';

interface LocalyControlledProps {
  setShowModal: Dispatch<SetStateAction<boolean>>; // mandatory
  showModal: boolean; // mandatory
  confirmText?: string;
  additionalOnOkExecution?: Function;
  additionalParam?: { name: string; value: string };
  useContext?: boolean;
}

interface GloballyControlledProps {
  setShowModal?: Dispatch<SetStateAction<boolean>>;
  showModal?: boolean;
  confirmText?: string;
  additionalOnOkExecution?: Function;
  additionalParam?: { name: string; value: string };
  useContext: boolean; // mandatory
}

type UnauthenticatedModalProps = LocalyControlledProps | GloballyControlledProps;

const UnauthenticatedModal = ({
  setShowModal = () => {},
  showModal = false,
  additionalOnOkExecution,
  additionalParam,
  useContext = false,
}: UnauthenticatedModalProps) => {
  const intl = useIntl();
  const location = useLocation();
  const { isVisible } = useAuthState();
  const authDispatch = useAuthDispatch();

  const disableAuthentication = window?.runConfig?.disableAuthentication;
  const { setSessionValue } = useSessionStorage<string | null | undefined>('SAVE_LOCATION');

  const onOk = () => {
    const params = new URLSearchParams(window.location.search);
    if (additionalParam) {
      params.append(additionalParam.name, additionalParam.value);
    }
    setSessionValue(location.pathname + (params ? '?' + params.toString() : null));
    window.location.replace(routes.api.baseUrl + '/vpm/login');
    additionalOnOkExecution?.();
  };

  const updateVisibility = (state: boolean) =>
    useContext ? authDispatch({ type: state ? 'SHOW' : 'HIDE' }) : setShowModal(false);

  return (
    <Modal
      className="unauthenticated-modal"
      onCancel={() => updateVisibility(false)}
      open={useContext ? isVisible : showModal}
      closable={false}
      disableHeader
      centered
      width={300}
      footer={
        <ButtonListModal>
          <Button
            label={intl.formatMessage({
              id: 'general.cancel',
            })}
            onClick={() => updateVisibility(false)}
          />
          {!disableAuthentication && (
            <Button
              label={intl.formatMessage({
                id: 'general.authenticate',
              })}
              type="primary"
              onClick={onOk}
            />
          )}
        </ButtonListModal>
      }
      getContainer={document.getElementById('root') as HTMLDivElement}
    >
      <Flex vertical justify="center" align="center" gap={20}>
        <div>
          <Icon className="fingerprint-icon" faBase="fa" icon="fingerprint" />
        </div>
        {disableAuthentication ? (
          <FormattedMessage id="general.login_disabled" />
        ) : (
          <FormattedMessage
            id="general.need_to_login"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
              p: (chunks) => <label>{chunks}</label>,
              br: () => <br />,
            }}
          />
        )}
      </Flex>
    </Modal>
  );
};

export default UnauthenticatedModal;
